import React, { useCallback } from "react";

const NonRevenueItem = ({
  avgResidentialMeter,
  avgBusinessMeter,
  avgBulkUsage,
  totalBusinessMeter,
  totalResidentialMeter,
  nonRevenueWater,
}) => {
  return (
    <>
      <tr>
        <td>Residential meters</td>
        <td className="text-center">{totalResidentialMeter}</td>
        <td className="text-center">{avgResidentialMeter}</td>
      </tr>
      <tr>
        <td>Business meters</td>
        <td className="text-center">{totalBusinessMeter}</td>
        <td className="text-center">{avgBusinessMeter}</td>
      </tr>
      <tr>
        <td>Other usage</td>
        <td></td>
        <td className="text-center">0</td>
      </tr>
      <tr>
        <td>Bulk usage</td>
        <td className="text-center"></td>
        <td className="text-center">{avgBulkUsage}</td>
      </tr>
      <tr>
        <td>Non revenue water</td>
        <td></td>
        <td className="text-center">{nonRevenueWater}</td>
      </tr>
      <tr>
        <td>NRW %</td>
        <td></td>
        <td className="text-center">{((nonRevenueWater / avgBulkUsage) * 100).toFixed(1)}%</td>
      </tr>
    </>
  );
};

export default NonRevenueItem;
